import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { DxGridColumn } from "./column/dx-grid-column";
import { DxGridToolbarOptions } from "./toolbar/dx-grid-toolbar-options";
import { DxGridPaginationOptions } from "./dx-grid-pagination-options";
import { DxInfiniteScrollOptions } from "./dx-infinite-scroll-options";
import { PitRequestHiddenCriteria } from "../../../pit-shared/domain/requests/pit-request-hidden-criteria";
/** Опций грида. */
let DxGridOptions = class DxGridOptions {
    /** Опций грида. */
    constructor() {
        /**
         * Автонастройка высоты грида под содержимое.
         * Если не установлено, то грид должен быть встроен в контейнер с фиксированной высотой, иначе он не отобразится.
         */
        this._autoHeight = true;
        /** Переключение грида на серверную модель данных. */
        this._useServerSideDataModel = false;
        /**
         * Включение режима пагинации.
         * Если пагинация не используется и активирована серверная модель данных грида,
         * то для пролистования будет применена модель бесконечного скрола. По-сути, таже пагинация,
         * только транспонированная.
         */
        this._allowPagination = false;
        /**
         * Переключение режимов редактирования данных грида:
         * 1. Редактирование строки напрямую через виджеты ячеек.
         * 2. Редактирование строки через отдельно предоставляемую модальную форму.
         * Эту настроку имеет смысл выставлять дря грида в целом, а не отдельных колонок.
         */
        this._useInlineEdit = false;
        /** Используется \ не используется панель инструментов для данного грида. */
        this._showToolbar = false;
        /**
         * Признак использования внешнего хэндлера для действий на тулбаре для данного грида.
         * Это позволяет использовать логику отрисовки и измененния доступности кнопок на панели инструментов,
         * но саму обработку действий вести вне грида. Работа с гридом идет через API. Это нужно при сильно кастомной
         * обработке действий.
         */
        this._externalToolbarHandler = false;
        /** Включение множественной отмеки строк. По умолчанию единичная. */
        this._allowMultiSelect = false;
        /** Отображение в шапке таблицы строки с фильтрами floatingFilter  */
        this._showFiltersBar = false;
        /**
         * Для постоянных/скрытых критериев рекомендуется поле {@link hiddenCriteria} к использованию.
         * Но если нет возможности уложить query запроса в эту структуру по какой-то причине, либо надо
         * внести данные поля в тело {@link PitRequestBody}, то укладываем сюда
         */
        this.criterias = new Map();
        /**
         * Поле для передачи дополнительных критериев фильтрации и сортировки, которые сливаются
         * с пользовательские критерииями (сначала эти, и поверх пользовательские из {@link DxGridDatasource})
         * См. методы {@link PitActivitiesService.getSortParams}, {@link PitActivitiesService.getFilterParams},
         * которые позже могут стать общими
         */
        this.hiddenCriteria = new PitRequestHiddenCriteria();
    }
    get hasDictColumns() {
        if (this._columns && this._columns.length > 0) {
            const dictColumns = this._columns.filter(column => column.dataType.isDictionary);
            return dictColumns && dictColumns.length > 0;
        }
        return false;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get ident() {
        return this._ident;
    }
    set ident(value) {
        this._ident = value;
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get useServerSideDataModel() {
        return this._useServerSideDataModel;
    }
    set useServerSideDataModel(value) {
        this._useServerSideDataModel = value;
    }
    get dataSourceIdent() {
        return this._dataSourceIdent;
    }
    set dataSourceIdent(value) {
        this._dataSourceIdent = value;
    }
    get infiniteScrollOptions() {
        return this._infiniteScrollOptions;
    }
    set infiniteScrollOptions(value) {
        this._infiniteScrollOptions = value;
    }
    get allowPagination() {
        return this._allowPagination;
    }
    set allowPagination(value) {
        this._allowPagination = value;
    }
    get paginationOptions() {
        return this._paginationOptions;
    }
    set paginationOptions(value) {
        this._paginationOptions = value;
    }
    get useInlineEdit() {
        return this._useInlineEdit;
    }
    set useInlineEdit(value) {
        this._useInlineEdit = value;
    }
    get rowFactoryIdent() {
        return this._rowFactoryIdent;
    }
    set rowFactoryIdent(value) {
        this._rowFactoryIdent = value;
    }
    get modalsProviderIdent() {
        return this._modalsProviderIdent;
    }
    set modalsProviderIdent(value) {
        this._modalsProviderIdent = value;
    }
    get showToolbar() {
        return this._showToolbar;
    }
    set showToolbar(value) {
        this._showToolbar = value;
    }
    get toolbar() {
        return this._toolbar;
    }
    set toolbar(value) {
        this._toolbar = value;
    }
    get externalToolbarHandler() {
        return this._externalToolbarHandler;
    }
    set externalToolbarHandler(value) {
        this._externalToolbarHandler = value;
    }
    get actionResolverIdent() {
        return this._actionResolverIdent;
    }
    set actionResolverIdent(value) {
        this._actionResolverIdent = value;
    }
    get columns() {
        return this._columns;
    }
    set columns(value) {
        this._columns = value;
    }
    get allowMultiSelect() {
        return this._allowMultiSelect;
    }
    set allowMultiSelect(value) {
        this._allowMultiSelect = value;
    }
    get showFiltersBar() {
        return this._showFiltersBar;
    }
    set showFiltersBar(value) {
        this._showFiltersBar = value;
    }
    get autoHeight() {
        return this._autoHeight;
    }
    set autoHeight(value) {
        this._autoHeight = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxGridOptions.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridOptions.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonMember({ name: "title", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridOptions.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonMember({ name: "autoHeight", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridOptions.prototype, "_autoHeight", void 0);
tslib_1.__decorate([
    jsonMember({ name: "useServerSideDataModel", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridOptions.prototype, "_useServerSideDataModel", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dataSourceIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridOptions.prototype, "_dataSourceIdent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "infiniteScrollOptions", constructor: DxInfiniteScrollOptions, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", DxInfiniteScrollOptions)
], DxGridOptions.prototype, "_infiniteScrollOptions", void 0);
tslib_1.__decorate([
    jsonMember({ name: "allowPagination", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridOptions.prototype, "_allowPagination", void 0);
tslib_1.__decorate([
    jsonMember({ name: "paginationOptions", constructor: DxGridPaginationOptions, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", DxGridPaginationOptions)
], DxGridOptions.prototype, "_paginationOptions", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxGridOptions.prototype, "headerHeight", void 0);
tslib_1.__decorate([
    jsonMember({ name: "useInlineEdit", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridOptions.prototype, "_useInlineEdit", void 0);
tslib_1.__decorate([
    jsonMember({ name: "rowFactoryIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridOptions.prototype, "_rowFactoryIdent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "modalsProviderIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridOptions.prototype, "_modalsProviderIdent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "showToolbar", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridOptions.prototype, "_showToolbar", void 0);
tslib_1.__decorate([
    jsonMember({ name: "toolbar", constructor: DxGridToolbarOptions, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", DxGridToolbarOptions)
], DxGridOptions.prototype, "_toolbar", void 0);
tslib_1.__decorate([
    jsonMember({ name: "externalToolbarHandler", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridOptions.prototype, "_externalToolbarHandler", void 0);
tslib_1.__decorate([
    jsonMember({ name: "actionResolverIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridOptions.prototype, "_actionResolverIdent", void 0);
tslib_1.__decorate([
    jsonArrayMember(DxGridColumn, { name: "columns", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], DxGridOptions.prototype, "_columns", void 0);
tslib_1.__decorate([
    jsonMember({ name: "allowMultiSelect", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridOptions.prototype, "_allowMultiSelect", void 0);
tslib_1.__decorate([
    jsonMember({ name: "showFiltersBar", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridOptions.prototype, "_showFiltersBar", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: PitRequestHiddenCriteria, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitRequestHiddenCriteria)
], DxGridOptions.prototype, "hiddenCriteria", void 0);
DxGridOptions = tslib_1.__decorate([
    jsonObject
], DxGridOptions);
export { DxGridOptions };
